export default "__VITE_ASSET__4e1289d8__"